module.exports = __webpack_public_path__ + "img/contact-avatar.6f0ffcb4.svg";